/**
 * Full CDN bundle entry point - includes all payment methods
 * This file exports PaymentKit with all payment methods pre-bundled
 */

import PaymentKit from "./index";
import affirm from "./payment-methods/affirm";
import afterpay from "./payment-methods/afterpay";
import applePay from "./payment-methods/apple-pay";
import card from "./payment-methods/card";
import googlePay from "./payment-methods/google-pay";
import klarna from "./payment-methods/klarna";
import paypal from "./payment-methods/paypal";
import stripeLink from "./payment-methods/stripe-link";

// Export the main PaymentKit function
export default PaymentKit;

// Export all payment methods for convenience
export const PaymentMethods = {
  applePay,
  card,
  googlePay,
  paypal,
  klarna,
  afterpay,
  affirm,
  stripeLink,
};

// Export types
export type { PaymentKitFields } from "./types";
